




















































import { defineComponent } from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import { useTax } from '~/composables';
import { getProductAssetsDomain } from '~/modules/catalog/category/components/tiles/assetsHelper';
import { SimpleProductInterface } from '~/modules/catalog/category/components/tiles/simpleProductInterface';
import { getPriceWithTaxAndFormatUsingProduct } from '~/modules/catalog/pricing/useTaxPrice';

export default defineComponent({
  components: { SimpleImage },
  props: {
    product: {
      type: Object as () => SimpleProductInterface,
      required: true,
    },
    imageSize: {
      type: Object as () => { width: number, height: number },
      required: false,
      default: () => ({
        width: 110,
        height: 110,
      }),
    },
    isBestSeller: {
      type: Boolean,
    },
  },
  setup() {
    const { vatLabel } = useTax();

    return {
      vatLabel,
      getPriceWithTaxAndFormatUsingProduct,
      getProductAssetsDomain,
    };
  },
});
